import {
  MY_SESSION_ACCESS,
  FETCH_LIVE_SESSIONS,
  SINGLE_SESSION_DETAILS
} from '../actions';

export function myLiveSessionAccess(state = [], action) {
  switch (action.type) {
    case MY_SESSION_ACCESS:
      return action.payload;
    default:
      return state;
  }
}

export function liveSessions(state = {}, action) {
  switch (action.type) {
    case FETCH_LIVE_SESSIONS:
      return action.payload;
    default:
      return state;
  }
}

export function singleSessionDetails(state = [], action) {
  switch (action.type) {
    case SINGLE_SESSION_DETAILS:
      return action.payload;
    default:
      return state;
  }
}
